import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveGender } from '../../../store/ducks/user';
import SettingsContainer from '../../../components/settings-container';
import GenderSelect from '../../../components/gender-select';

import './index.css';

class GenderPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gender: props.gender
    };

    this.handleSelectFemale = () => this.handleGenderSelected('female');
    this.handleSelectMale = () => this.handleGenderSelected('male');
  }

  handleGenderSelected(gender) {
    this.setState({ gender });
  }

  save = async () => {
    try {
      await this.props.saveGender(this.state.gender);
    } catch (e) {
      /* do nothing */
    }
  }

  render() {
    return (
      <SettingsContainer
        className="gender-page"
        pageTitle="What's your gender?"
        save={ this.save }
        hideSkip={ this.props.appName === 'wolf' }
        isValid={ Boolean(this.state.gender) }
      >
        <GenderSelect
          gender={ this.state.gender }
          handleSelectFemale={ this.handleSelectFemale }
          handleSelectMale={ this.handleSelectMale }
        />
      </SettingsContainer>
    );
  }
}

GenderPage.propTypes = {
  gender: PropTypes.oneOf(['male', 'female', '']),
  appName: PropTypes.string,
  saveGender: PropTypes.func.isRequired
};

export default connect(
  state => ({
    gender: state.user.gender,
    appName: state.config.appName,
  }),
  dispatch => ({
    saveGender: gender => dispatch(saveGender(gender))
  }),
  null,
  { withRef: true }
)(GenderPage);
